export default __webpack_public_path__ + "static/media/icon-senha.e0108540.svg";